<template>
  <v-container fluid>
    <a-form-model layout="vertical" :hideRequiredMark="true">
      <a-row :gutter="4">
        <a-col :span="24" :xxl="3" :xl="4" :lg="4" :md="8">
          <a-form-model-item label="查询方式">
            <a-input v-model="queryForm.nos" placeholder="订单号" allow-clear />
          </a-form-model-item>
        </a-col>
        <a-col :span="24" :xxl="2" :xl="3" :lg="3" :md="6">
          <a-form-model-item label="查询方式">
            <a-select v-model="queryForm.day_type" placeholder="查询方式" :not-found-content="null">
              <a-select-option key="order_accept_t"> 接单日期 </a-select-option>
              <a-select-option key="load_t"> 装车日期 </a-select-option>
              <a-select-option key="unload_t"> 卸车日期 </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="24" :xxl="4" :xl="6" :lg="6" :md="12">
          <a-form-model-item label="时间">
            <a-range-picker v-model="queryForm.times" :locale="locale" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
              :allow-clear="false" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
          <a-form-model-item label="车牌号">
            <a-input v-model="queryForm.vehicle_number" placeholder="车牌号" allow-clear>
            </a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
          <a-form-model-item label="司机姓名">
            <a-input v-model="queryForm.driver_name" placeholder="司机姓名" allow-clear>
            </a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
          <a-form-model-item label="司机手机号">
            <a-input v-model="queryForm.driver_mobile" placeholder="司机手机号" allow-clear>
            </a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="24" :xxl="4" :xl="6" :lg="3" :md="12">
          <div class="d-flex align-end" style="margin-top:15px;height:42px;">
            <a-space>
              <v-btn tile small class="primary white--text" @click="getdata()">
                <v-icon small>mdi-magnify</v-icon>查询
              </v-btn>
            </a-space>
          </div>
        </a-col>
      </a-row>
    </a-form-model>
    <v-card tile class="mt-2">
      <v-data-table dense :headers="headers" :items="list" :items-per-page="list.length" no-data-text="无数据"
        hide-default-footer disable-sort fixed-header :height="height">
        <template v-slot:item.line="{ item }">
          <a-tag color="red">{{ item.departure }}</a-tag>
          <p>⬇️</p>
          <a-tag color="green">{{ item.destination }}</a-tag>
        </template>
      </v-data-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
  </v-container>
</template>

<script>
import _ from "underscore";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { mapState } from "vuex";
export default {
  name: "OrderEList",
  data() {
    return {
      locale,
      queryForm: {
        nos: "",
        day_type: 'order_accept_t',
        times: [null, null],
        vehicle_number: null,
        driver_name: null,
        driver_mobile: null,
      },
      headers: [
        { text: "订单号", value: "order_number", width: 150, align: "center" },
        { text: "线路", value: "line", width: 150, align: "center" },
        { text: "费用", value: "fee", width: 150, align: "center" },
        { text: "司机", value: "driver", width: 120, align: "center" },
        { text: "车牌号", value: "vehiclel_number", width: 120, align: "center" },
        { text: "公司信息", value: "project", width: 120, align: "center" },
        { text: "订单时间", value: "time", width: 120, align: "center" },
      ],
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      height: 600,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: {},
  watch: {
    '$route.query.nos'(nos) {
      if (nos) {
        this.queryForm.nos = (nos || "").split(',').join('\n');
        this.getdata();
      }
    },
    page() {
      this.getdata();
    },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
  },
  mounted() {
    this.height = window.innerHeight - 300;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 300;
    };
    this.page = 1;
    this.list = [];
    this.length = 0;
    this.count = 0;
    this.queryForm = {
      nos: (this.$route.query.nos || "").split(',').join('\n'),
      day_type: 'order_accept_t',
      times: [
        this.$moment().subtract(3, 'day').format('YYYY-MM-DD'),
        this.$dateFormat(),
      ],
      vehicle_number: null,
      driver_name: null,
      driver_mobile: null,
    }
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/fengyubill/list", {
        page: this.page,
        limit: this.limit,
        ...this.queryForm,
      }).then((res) => {
        this.$toast.clear();
        // console.log(res);
        if (res.code === 0) {
          this.list = res.data.list;
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: unset;
}

/deep/ .row+.row {
  margin-top: 0;
}

/deep/ .col {
  padding: 4px;
}

p {
  margin: 0;
}
</style>
